import { useAuth } from '../../../../app/modules/auth';
import { KTSVG, toAbsoluteUrl } from '../../../helpers';
import { UserMenu } from '../user-menu/UserMenu';
import { useProfilePic } from '../../../../app/hooks/useProfilePic';
import { useState } from 'react';

const AsideUserMenu = () => {
    const { currentUser } = useAuth();
    const { getProfilePicUrl } = useProfilePic();
    const [imageError, setImageError] = useState(false);
    
    const profilePicUrl = getProfilePicUrl();
    const hasValidUrl = profilePicUrl && !profilePicUrl.includes('undefined');
    
    const getInitials = () => {
        const firstname = currentUser?.firstname || '';
        const lastname = currentUser?.lastname || '';
        return `${firstname.charAt(0)}${lastname.charAt(0)}`.toUpperCase();
    };
    
    return (<>
      <div className='d-flex flex-stack'>
        {/* begin::Wrapper */}
        <div className='d-flex align-items-center'>
          {/* begin::Avatar */}
          <div className='symbol symbol-circle symbol-40px'>
            {hasValidUrl && !imageError ? (
              <img 
                src={profilePicUrl} 
                alt={`${currentUser?.firstname} ${currentUser?.lastname}`}
                onError={() => setImageError(true)}
              />
            ) : (
              <div 
                className='symbol-label fs-6 fw-bold text-white' 
                style={{ backgroundColor: '#6F90A7' }}
              >
                {getInitials()}
              </div>
            )}
          </div>
          {/* end::Avatar */}
          {/* begin::User info */}
          <div className='ms-2'>
            <a href='#' className='text-gray-800 text-hover-primary fs-6 fw-bolder lh-1'>
              {currentUser?.firstname} {currentUser?.lastname}
            </a>
            <span className='text-muted fw-bold d-block fs-7 lh-1'>{localStorage.getItem('user_type')}</span>
          </div>
          {/* end::User info */}
        </div>
        {/* end::Wrapper */}

        {/* begin::User menu */}
        <div className='ms-1'>
          <div className='btn btn-sm btn-icon btn-active-color-primary position-relative me-n2' data-kt-menu-trigger='click' data-kt-menu-overflow='false' data-kt-menu-placement='top-end'>
            <KTSVG path='/media/icons/duotune/coding/cod001.svg' className='svg-icon-1'/>
          </div>
          <UserMenu />
        </div>
        {/* end::User menu */}
      </div>
    </>);
};
export { AsideUserMenu };
